const trackerBaseReportsConstants = {
    rootStateName: "tbReports"
};

export default Object.freeze(trackerBaseReportsConstants);



//////////////////
// WEBPACK FOOTER
// ./src/views/trackerbase-reports/Constants.js
// module id = xMnc
// module chunks = 1